export default function () {
  const hamburger = document.querySelector('.site-header__hamburger');
  const popup = document.querySelector('.site-header__popup');
  const closeBtn = document.querySelector('.site-header__popup__close');

  if (!hamburger || !popup || !closeBtn) return;

  // Open popup
  hamburger.addEventListener('click', () => {
    popup.classList.add('active');
  });

  // Close popup
  closeBtn.addEventListener('click', () => {
    popup.classList.remove('active');
  });
}